module.exports = __webpack_public_path__ + "img/tile-keyframes-desktop_en.1b9c761.jpg";